import React from "react";
import * as IconsSVG from "../../../../../../assets/iconsSVG";
import * as Styles from "../../styles";
import { CustomTooltip } from "../../customTooltip";
import { Lead } from "../../../../../../interfaces";

interface Props {
  item: Lead;
  onProdutoClick: (item: Lead) => void;
  readOnly?: boolean;
}

export const ProdutoCell: React.FC<Props> = ({
  item,
  onProdutoClick,
  readOnly,
}) => (
  <CustomTooltip
    followCursor
    title={
      <>
        <Styles.HeaderContainer>Produtos de preferência</Styles.HeaderContainer>
        <Styles.ContentEmp>
          {item?.empreendimentos?.length > 0 ? (
            item.empreendimentos.map((emp: any) => (
              <li key={emp.id}>
                <IconsSVG.BusinessIcon color="white" />
                <p>{emp.nome}</p>
              </li>
            ))
          ) : (
            <p style={{ textAlign: "center" }}>Sem produtos</p>
          )}
        </Styles.ContentEmp>
      </>
    }
    placement="top-start"
  >
    <Styles.Td
      className="prodTd"
      style={{
        position: "relative",
        overflow: "unset",
        cursor: readOnly ? "default" : "pointer",
      }}
      onClick={readOnly ? undefined : () => onProdutoClick(item)}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        {item?.empreendimentos?.length > 0 ||
        item?.empreendimentos?.[0]?.nome === null ? (
          <p className="nomeEmp">{item.empreendimentos.slice(-1)[0].nome}</p>
        ) : (
          "Sem produto"
        )}
      </div>
    </Styles.Td>
  </CustomTooltip>
);
